import { request } from '../axios/request';

import {
  FETCH_PACKAGE_ORDER_LIST_PENDING,
  FETCH_PACKAGE_ORDER_LIST_REJECTED,
  FETCH_PACKAGE_ORDER_LIST_FULFILLED,
  START_PACKAGE_ORDER_LIST_AUTO_RELOAD,
  STOP_PACKAGE_ORDER_LIST_AUTO_RELOAD,
  SET_ACTIVE_STATUS_FOR_PACKAGE_ORDER_LIST,
  CLEAR_PACKAGE_ORDER_LIST,
  FETCH_FILTER_ATTRS_FULFILLED,
  SELECTED_FILTER_ATTRS,
} from '../constants/packageOrderList';

const OMS = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: FETCH_PACKAGE_ORDER_LIST_PENDING,
});

const fulfilled = (data) => ({
  type: FETCH_PACKAGE_ORDER_LIST_FULFILLED,
  data,
});

export const saveSelectedFilterAttrs = (data) => ({
  type: SELECTED_FILTER_ATTRS,
  data,
});

const fulfilledFilterAttrs = (data) => ({
  type: FETCH_FILTER_ATTRS_FULFILLED,
  data,
});

const rejected = (error) => ({
  type: FETCH_PACKAGE_ORDER_LIST_REJECTED,
  error,
});

const startAutoReloadInterval = (data) => ({
  type: START_PACKAGE_ORDER_LIST_AUTO_RELOAD,
  data,
});

const stopAutoReloadInterval = () => ({
  type: STOP_PACKAGE_ORDER_LIST_AUTO_RELOAD,
});

export const clearPackageOrderList = () => ({
  type: CLEAR_PACKAGE_ORDER_LIST,
});

export const setActiveStatus = (data) => ({
  type: SET_ACTIVE_STATUS_FOR_PACKAGE_ORDER_LIST,
  data,
});

export const fetchPackageOrders =
  (params = {}) =>
  (dispatch, getState) => {
    const {
      packageOrderList: { activeStatusId },
    } = getState();
    const _params = {
      state: activeStatusId,
      ...params,
      limit: 50,
      page: 1,
    };
    dispatch(pending());
    dispatch(setActiveStatus(_params.state));

    request({
      method: 'get',
      url: OMS.OMS.PACKAGE_ORDER_LIST,
      params: _params,
    })
      .then((response) => {
        const { data } = response;
        dispatch(fulfilled(data));
      })
      .catch((error) => {
        dispatch(rejected(error));
      });
  };

export const getFilterAttrs = () => (dispatch) => {
  return request({ method: 'get', url: OMS.OMS.FILTERS_URL }).then(
    (response) => {
      const { data } = response;
      dispatch(fulfilledFilterAttrs(data));
    }
  );
};

export const startAutoReload = (milliseconds) => (dispatch) => {
  const autoReloadIntervalId = setInterval(() => {
    dispatch(fetchPackageOrders());
  }, milliseconds);

  dispatch(startAutoReloadInterval(autoReloadIntervalId));
};

export const stopAutoReload = () => (dispatch, getState) => {
  const {
    packageOrderList: { autoReloadIntervalId },
  } = getState();
  if (!autoReloadIntervalId) return;

  clearInterval(autoReloadIntervalId);
  dispatch(stopAutoReloadInterval());
};



// WEBPACK FOOTER //
// ./src/actions/packageOrderList.js